import { t } from '@ctcells/i18n'

import { moduleLabelOf } from './format.ts'

/**
 * **모듈 묶음 — 공통 · 원심분리기 · 어셈블러 · 염색기 · 운송 로봇 · 시약**(이름 · 차례 한 곳).
 *
 * 🔴 두 화면이 같은 묶음을 쓴다 — 작업 시작의 사전 점검 표(`GroupedPreflightReport`)와 관리 › 설정 «알람별 전달» 표
 *    (eric 2026-10-28 「작업 시작 누르면 공통 .. 이렇게 여러 카테고리로 나누는 것처럼.. 그렇게 나눠 줘」). 차례를 따로 두지 마라.
 * ⚠ 어느 묶음에 넣는지(판정)는 화면마다 근거가 달라 각자 둔다 — 사전 점검은 행의 `module_id` · `item`,
 *   알람별 전달은 사전의 `source`(`alarmModuleGroup` · `alarmRoutingModel.ts`).
 */
export const MODULE_GROUPS = ['common', 'cent', 'asm', 'stain', 'robot', 'reagents'] as const

export type ModuleGroup = (typeof MODULE_GROUPS)[number]

/** 묶음 이름 — 공통 · 시약은 사전 점검 문구, 장비는 장비 이름(`moduleLabelOf`) */
export function moduleGroupLabel(group: ModuleGroup): string {
  return group === 'common' || group === 'reagents'
    ? t(`preflight.group.${group}`)
    : moduleLabelOf(group)
}
